module.exports = {"sortable":{"labels":{"sort":"Activate sorting","done":"Done sorting"}}}


//////////////////
// WEBPACK FOOTER
// ./components/Custom/Sortable/sortable-en.json
// module id = 3xNk
// module chunks = 18